{
  "id": "campaign-114",
  "name": "Bushy Promenade",
  "seed": "campaign:114",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,,CCCCCC,,...,",
    ",,,,,,UCCCCU,,...,",
    ",,,,,,,,CC,,,,...x",
    ",,****,,CC,,****,,",
    ",,,,,t,BCCB,t,,,,,",
    ",T,T,,~CCCC,,,T,T,",
    ",,,,,,~CwwC,,,,,,,",
    ",,,,,,~CwwC,,,,,,,",
    ",,,,,t,CwwC,t,,,..",
    ",,,,,,,CCCC,,,,...",
    ",,Y,,,,,CC,,,,,Y..",
    ",,,,,,,BCCB,,,,...",
    ",,,..t,,CC,,t,,,..",
    ",,.....,CC,,,,,,,,",
    ",,.h.t.,CC,,t,h..,",
    "x,.....,CC,,,,...,",
    "..,.,,,,x,,,,,....",
    "S...,,,,,,,,x,...."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 17,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 15,
      "y": 0
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 14,
      "y": 16
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 1,
      "y": 8
    },
    {
      "kind": "gas",
      "x": 7,
      "y": 15
    },
    {
      "kind": "gas",
      "x": 16,
      "y": 8
    },
    {
      "kind": "gas",
      "x": 16,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 16,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 4
    }
  ],
  "generatorVersion": 3,
  "level": 114,
  "biome": "estate",
  "par": {
    "reel": 10637,
    "push": 9282,
    "selfPropelled": 8436,
    "tractor": 6661,
    "zeroTurn": 5799,
    "fairway": 3477
  },
  "goldTime": {
    "reel": 10517,
    "push": 9009,
    "selfPropelled": 8388,
    "tractor": 6661,
    "zeroTurn": 5731,
    "fairway": 3346
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 7
    },
    "gold": {
      "reel": 25,
      "push": 25,
      "selfPropelled": 25,
      "tractor": 0,
      "zeroTurn": 25,
      "fairway": 34
    }
  }
}
